import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import './PaypalPayment.css';
import axios from 'axios';
import { clearEnrollments } from '../../ReduxStore/EnrollSlice';
import { useNavigate } from 'react-router-dom';
import { clearCart, COURSES_URL, ENROLLMENT_URL, getCartItems, JOBS_PORTAL_URL } from '../../Services/courseService';
import { useTranslation } from 'react-i18next';
import ClipLoader from "react-spinners/ClipLoader";
import cardPayment from '../../Assets/card-payment2.png';

const RazorPay = () => {
    const [paymentStatus, setPaymentStatus] = useState(null);
    const [orderIsPaid, setOrderIsPaid] = useState(false);
    const [paymentError, setPaymentError] = useState(false);
    const [alreadyEnrolled, setAlreadyEnrolled] = useState(false);
    const [popupVisible, setPopupVisible] = useState(false);
    const [cartItems, setCartItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userId = localStorage.getItem('userId');
    const fullName = localStorage.getItem('fullName');
    const email = localStorage.getItem('email');
    const phoneNumber = localStorage.getItem('phoneNumber' || null);
    const { t } = useTranslation();

    const courses = useSelector(state => state?.EnrollSlice?.course) || [];
    const totalAmount = courses?.reduce((acc, course) => acc + course?.price, 0).toFixed(2);
    const [promoCode, setPromoCode] = useState('');
    const [finalAmount, setFinalAmount] = useState(totalAmount);
    const [promoApplied, setPromoApplied] = useState(false);

    const fetchCartItems = useCallback(async () => {
        try {
            const response = await getCartItems(userId, '');
            setCartItems(response?.cartItems || []);
        } catch (error) {
            console.error('Error fetching cart items:', error);
        }
    }, [userId]);


function getOffsetDateTime() {
  const date = new Date();
  const offsetMinutes = date.getTimezoneOffset(); // e.g., -330 for IST
  const absOffsetMinutes = Math.abs(offsetMinutes);
  const sign = offsetMinutes <= 0 ? '+' : '-';
  const pad = (n) => String(n).padStart(2, '0');

  const offsetHours = pad(Math.floor(absOffsetMinutes / 60));
  const offsetMins = pad(absOffsetMinutes % 60);
  const offsetStr = `${sign}${offsetHours}:${offsetMins}`;

  const localISO = new Date(date.getTime() - offsetMinutes * 60000)
    .toISOString()
    .split('.')[0];

  return `${localISO}${offsetStr}`;
}

console.log(getOffsetDateTime())

    useEffect(() => {
        if (!orderIsPaid) {
            fetchCartItems();
        }

        if (courses.length === 0 && !orderIsPaid && !popupVisible) {
            navigate('/');
        }
    }, [orderIsPaid, courses.length, navigate, fetchCartItems, popupVisible]);

    const hanldeApplyPromo = async () => {
        toast.dismiss();

        if (!promoCode) {
            toast.error("Please enter a promo code");
            return;
        }

        try {
            const res = await axios.post(`${JOBS_PORTAL_URL}/api/promocode/apply`, {
                code: promoCode,
                userId: userId,
                originalPrice: totalAmount
            });
            localStorage.removeItem('appliedPromoCode');

            if (res?.data?.finalPrice != null) {
                localStorage.setItem('appliedPromoCode', promoCode);

                const cleanFinal = parseFloat(res.data.finalPrice).toFixed(2);
                setFinalAmount(cleanFinal);
                setPromoApplied(true);
                toast.success("Promo code applied successfully!");
            } else {
                toast.error("Invalid promo code");
            }
        } catch (e) {
            if (e.response.data) {
                toast.error(e.response.data);

            }
            else {
                toast.error("Failed to apply promo code");

            }
        }
    };
const handlePayment = async () => {
    try {
        setButtonLoading(true);

        const totalAmountInt = Math.round(parseFloat(finalAmount)); // finalAmount should already reflect the discount
        const appliedPromoCode = localStorage.getItem('appliedPromoCode');

        // Prepare payload for backend
        const payload = {
            amount: totalAmountInt
        };

        if (appliedPromoCode) {
            payload.promoCode = appliedPromoCode;
            payload.userId = userId; // needed for promo validation
        }

        // Step 1: Create Razorpay Order
        const response = await axios.post(`${COURSES_URL}/payments/create-order`, payload);
        const orderId = response.data.orderId;

        const options = {
            key: `${process.env.REACT_APP_RAZORPAY_KEY}`,
            amount: totalAmountInt * 100,
            currency: "INR",
            order_id: orderId,

            handler: async function (response) {
                try {
                    const { razorpay_payment_id, razorpay_order_id, razorpay_signature } = response;

                    if (!razorpay_payment_id || !razorpay_order_id || !razorpay_signature) {
                        throw new Error('Payment verification failed. Missing required information.');
                    }

                    // Step 2: Verify Payment
                    const verificationResponse = await axios.post(`${COURSES_URL}/payments/verify-payment`, {
                        razorpay_payment_id,
                        razorpay_order_id,
                        razorpay_signature,
                    });

                    if (verificationResponse.status === 200) {
                        setLoading(true);
                        setOrderIsPaid(true);
                        setAlreadyEnrolled(false);

                        try {
                            const enrollmentDTO = {
                                courses: courses?.map(course => ({
                                    courseId: course?.courseId,
                                    courseName: course?.title,
                                })),
                                skilltecheraUserId: userId,
                                paymentId: razorpay_payment_id,
                                orderId: razorpay_order_id,
                                signature: razorpay_signature,
                                totalAmount: totalAmountInt,
                                transactionDate: getOffsetDateTime(),
                                paymentType: "Razorpay",
                                purchasePurpose: "Course_Enrollment",
                                promoCode: appliedPromoCode || null // ✅ Send promoCode if applied
                            };

                            const paymentSaveRes = await axios.post(`${COURSES_URL}/payments`, enrollmentDTO);

                            console.log(getOffsetDateTime())
                            if (paymentSaveRes?.status === 200) {
                                // ✅ Update promo usage count for each course
                                for (const course of courses) {
                                    if (appliedPromoCode) {
                                        try {
                                            await axios.put(`${JOBS_PORTAL_URL}/api/promocode/promo-usage-count/${appliedPromoCode}/${userId}/${course?.courseId}/increment`);
                                        } catch (incrementError) {
                                            console.warn("Failed to increment promo code usage:", incrementError);
                                        }
                                    }
                                }

                                // ✅ Enroll in each course
                                for (const course of courses) {
                                    const courseData = {
                                        courseId: course?.courseId,
                                        skilltecheraUserId: userId,
                                        promoCode: appliedPromoCode || null // optional for backend if it tracks enrollment discount
                                    };

                                    try {
                                        const enrollResponse = await axios.post(`${ENROLLMENT_URL}/createEnrollment`, courseData);

                                        toast.dismiss();
                                        if (enrollResponse?.status === 404) {
                                            setAlreadyEnrolled(true);
                                            toast.error("You are already enrolled in this course");
                                            continue;
                                        } else if (enrollResponse?.status !== 200 && enrollResponse?.status !== 201) {
                                            setPaymentError(true);
                                            break;
                                        } else {
                                            navigate('/payment-success', { state: { from: 'checkout' } });
                                        }

                                        await clearCart(userId);
                                        dispatch(clearEnrollments());
                                    } catch (error) {
                                        toast.dismiss();
                                        if (error?.response?.status === 404) {
                                            setAlreadyEnrolled(true);
                                            toast.error("You are already enrolled in this course");
                                        } else {
                                            setPaymentError(true);
                                            break;
                                        }
                                    }
                                }

                                localStorage.removeItem('appliedPromoCode');

                                if (cartItems?.length > 0) {
                                    setCartItems([]);
                                }

                                setPopupVisible(true);
                            } else {
                                toast.dismiss();
                                toast.error('Unexpected response from the server.');
                            }
                        } catch (error) {
                            toast.dismiss();
                            setButtonLoading(false);
                            setPaymentError(true);
                            const message = error?.response?.data?.message || 'An error occurred during enrollment.';
                            toast.error(message);
                        } finally {
                            setButtonLoading(false);
                            setLoading(false);
                        }

                        setPaymentStatus('Payment verified successfully');
                    } else {
                        setPaymentStatus('Payment verification failed. Please try again.');
                    }
                } catch (error) {
                    setPaymentStatus('Error during payment verification');
                    console.error("Error verifying payment", error);
                }
            },

            prefill: {
                name: fullName,
                email: email,
                contact: phoneNumber
            },
            theme: {
                color: "#0B89C2"
            }
        };

        const razorpay = new window.Razorpay(options);
        razorpay.open();
    } catch (error) {
        setButtonLoading(false);
        console.error("Error creating order", error);
        setPaymentStatus('Failed to create order. Please try again.');
    } finally {
        setButtonLoading(false);
        console.log(paymentStatus);
    }
};


    useEffect(() => {
        if (!promoCode) {
            setFinalAmount(totalAmount);
            setPromoApplied(false);
        }
    }, [promoCode, totalAmount]);


    return (
        <div className="payment-main-container">
            <div className="payment-container">
                {loading && (
                    <div className="loading-overlay">
                        <ClipLoader color="#333" loading={loading} size={40} />
                    </div>
                )}

                {!orderIsPaid && (
                    <>
                        <h1 className="payment-header">{t("Let’s Make Payment")}</h1>
                        <p>{t("Complete your learning journey—secure your spot now with a quick payment! Click below to proceed and unlock your next step to success.")}</p>

                        <div className="course-summary">
                            <h2>{t("Courses")}</h2>
                            {courses?.map(course => (
                                <div key={course?.courseId} className="course-item-title">
                                    <p>{course?.title}</p>
                                    <p>  ₹{course?.price}</p>
                                </div>
                            ))}
                            <div className="course-item-title">
                                {/* <h3>{t("TotalAmount")}</h3>
                                <h3> ₹{totalAmount}</h3> */}
                                <input type='text'placeholder='Enter Promo Code' className='promo-input' onChange={(e)=>{setPromoCode(e.target.value);
                                setPromoApplied(false);
                                }}/>
                                <button onClick={hanldeApplyPromo} className='apply-discount-button'disabled={promoApplied}>Apply</button>
                            </div>
                        </div>
                        {promoApplied && (
                            <div>
                                <div className="course-item-title">
                                    <h3>{t("Discount")}</h3>
                                    <h3>
                                        ₹{(totalAmount - finalAmount).toFixed(2)} (
                                        {((100 * (totalAmount - finalAmount)) / totalAmount).toFixed(2)}%)
                                    </h3>
                                </div>
                                <div className="course-item-title">
                                    <h3> Final amount:</h3>
                                    <h3>₹{parseFloat(finalAmount).toFixed(2)}</h3>
                                </div>
                            </div>
                        )}
                        <button onClick={handlePayment} className='pay-now-button'>{buttonLoading ? 'Processing...' : 'Pay'}
                        </button>
                    </>
                )}

                {popupVisible && (
                    <div className='popup-overlay-payment'>
                        <div className='popup-content'>
                            {paymentError || alreadyEnrolled ? (
                                <div>
                                    <h2>{t('PaymentFailedTitle')}</h2>
                                    <p>{t('PaymentFailedMessage')}</p>
                                    <button onClick={() => navigate("/cart")}>{t('RetryButton')}</button>
                                </div>
                            ) : (
                                <div className='Payment-success-container'>
                                    <h2>{t('PaymentSuccessTitle')}</h2>
                                    <p>{t('PaymentSuccessMessage')}</p>
                                    {/* <button onClick={handlePopupClose} className='proceed-button'>
                                        {t('GoToCoursesButton')}
                                    </button> */}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
            <link rel="preload" href={cardPayment} as="image" />
            <img src={cardPayment} alt='payment-img' className='payment-img' />

        </div>
    );
};

export default RazorPay;
